import Joi from "joi";
import passwordComplexity from "joi-password-complexity";

import { LoginInput } from "~/types/input/auth.types";

export const loginValidationSchema = Joi.object<LoginInput>({
  username: Joi.string()
    .email({ tlds: false, allowUnicode: true })
    .required()
    .error(new Error("Email invalide.")),
  password: passwordComplexity()
    .required()
    .error(
      new Error("Au moins une majuscule, un caractère spécial et un chiffre.")
    ),
});
